export enum AppDeleteTitles {
  disabled = 'You cannot remove an application while connected to a hosting provider. Please uninstall from the hosting provider first.',
  enabled = 'Removed applications can be restored up to 365 days. After that time applications will be permanently deleted, together with all history, activity, etc.',
  title = 'You are about to remove:',
  confirm = 'Remove Application',
  cancel = 'Cancel',
  error = 'Application could not be deleted.',
  success = 'Application deleted successfully.',
}
